module.exports = __webpack_public_path__ + "img/@work_img1.fa49fff6.jpg";